<template>
  <v-app>
    <v-main class="pt-0">
      <v-parallax class="mb-6 hero-parallax" dark src="@/assets/img/hcl-hero-new.png" height="450">
        <v-row align="center" justify="end">
          <v-col cols="12" md="6" sm="12">
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="12" class="white--text text-center">
                  <v-img :src="heroImage" max-width="150px" class="d-block ml-auto mr-auto"></v-img>
                  <h1 class="font-weight-light display-2 mb-8">{{models.Model.toUpperCase() }}</h1>
                  <h1 class="font-weight-light display-2 mb-8">{{models.Manufacturer}}</h1>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-parallax>

        <v-row justify="start">
          <v-btn class="ma-2 ml-16" size="x-large" color="#041a41" @click="goToHome">
            <v-icon color="white" left>mdi-arrow-left</v-icon>
            <h3 style="color: white;">Voltar</h3>
          </v-btn>
        </v-row>

        <v-row align="center" justify="center">
          <v-col cols="12" md="6" sm="12">
      <v-card class="mb-12" variant="tonal">
        <v-card-title class="text-center">Detalhes do Hardware:</v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">Tipo</th>
                  <th class="text-center">Hardware</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(model, index) in models.Hardware_Details" :key="index">
                  <td style="font-weight: bold">{{ model.ht }}</td>
                  <td>{{ model.Manufacturer  +"  " + model.Hardware }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-alert v-if="models.length === 0" type="error">No models found</v-alert>
        </v-card-text>
      </v-card>
          </v-col>
        </v-row>
    </v-main>
    <footerSection />
  </v-app>
</template>

<script>
import axios from '@/utils/axios';
import footerSection from "@/components/Footer";

export default {
  components: {
    footerSection
  },
  data() {
    return {
      models: [],
      loading: false,
      error: '',
      heroImage: null

    }
  },
  created() {
    this.heroImage = require(`@/assets/img/gear.png`);
    this.fetchModels();
  },
  methods: {
      goToHome() {
        this.$router.go(-1);
      },
    async fetchModels() {
      this.loading = true;
      try {
        const response = await axios.get(`/api/getModelInfo.php?id=${this.$route.params.pathMatch}`);
        this.models = response.data;
      } catch (error) {
        console.error('Error:', error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.icon-hover:hover {
  color: blue;
}
</style>
